import cn from "classnames";
import { getInitials } from "@/shared/utils";

interface AvatarProps {
  name: string;
  size?: number;
  shape?: "circle" | "rectangle";
  textClassName?: string;
  bodyClassName?: string;
}

export default function Avatar({
  name,
  size = 32,
  shape = "circle",
  textClassName,
  bodyClassName,
}: AvatarProps) {
  const colorClasses = "surface-brand-subtle content-action-brand";

  const shapeClass = shape === "circle" ? "radius-full" : "radius-xs";

  return (
    <div
      className={cn("flex items-center justify-center shrink-0", colorClasses, shapeClass, bodyClassName)}
      style={{ width: size, height: size }}>
      <span className={cn("font-bold", textClassName)}>{getInitials(name).toUpperCase()}</span>
    </div>
  );
}
